import { User } from '../../model/User';
import { IAuthService } from '../IAuthService';

export class AuthService implements IAuthService {
  private instance: string;
  private onAuthStateChangedCallback: ((user: User) => void) = () => {};

  constructor(instance: string) {
    this.instance = instance;
  }

  async login(email: string, password: string): Promise<User> {
    const url = `https://${this.instance}.web.app/api/login`;
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email, password })
    };
    const response = await fetch(url, options);
    const result = await response.json();
    if(!response.ok) {
      throw new Error(result.message || 'Login failed');
    }
    sessionStorage.setItem('auth', JSON.stringify({ email, token: result.token, expiresAt: Date.now() + result.expiresIn }));
    this.onAuthStateChangedCallback({ email: result.email, name: result.name });
    return { email: email, name: this.instance };
  }

  async logout() {
    await fetch(`https://${this.instance}.web.app/api/logout`);
    sessionStorage.removeItem('auth');
    this.onAuthStateChangedCallback(null);
  }

  onAuthStateChanged(callback: (user: User) => void): () => void {
    this.onAuthStateChangedCallback = callback;
    const auth = sessionStorage.getItem('auth') || '';
    const token = auth ? JSON.parse(auth) : null;
    if(token && token.expiresAt > Date.now()) {
      callback({ email: token.email, name: this.instance });
    }
    else {
      callback(null);
    }
    return () => {};
  };
}